import { Flex, Text, Tag, space } from '@nula/core-ui';
import { MiniPageCard } from '@/components/document-cards/mini-page-card';
import { useLiveRecording } from '@/lib/recordings/use-live-recording';
import { RecordingDot } from '@/components/recording-dot/recording-dot';
import type { WorkspaceDoc } from '@/lib/sync/entity-types';
import tableStyles from '@/components/document-cards/library-table.module.css';

/**
 * The "Title" cell for a collection's list/table view: mini preview + title +
 * tags, plus a recording dot while the entity is actively being recorded. Its
 * own component (not an inline column render) so it can call the
 * useLiveRecording hook per row.
 */
export function CollectionTableNameCell({ doc }: { doc: WorkspaceDoc }) {
  const isRecording = useLiveRecording(doc.id)?.phase === 'capturing';

  return (
    <Flex align="center" gap={space[3]} className={tableStyles.nameCell}>
      <MiniPageCard
        previewMarkup={doc.previewMarkup}
        previewKind={doc.previewKind}
        kind={doc.kind}
      />
      <Flex vertical className={tableStyles.titleCol}>
        <Flex align="center" gap={space[2]}>
          <Text ellipsis className={tableStyles.titleText}>{doc.title || 'Untitled'}</Text>
          {isRecording && <RecordingDot />}
        </Flex>
        {doc.tags.length > 0 && (
          <Flex align="center" wrap gap={space[1]} className={tableStyles.tagsRow}>
            {doc.tags.slice(0, 3).map((tag) => (
              <Tag key={tag} bordered={false} className={tableStyles.tag}>{tag}</Tag>
            ))}
            {doc.tags.length > 3 && <Text size="xs" className={tableStyles.tagsOverflow}>+{doc.tags.length - 3}</Text>}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
